require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-21-c-4-tk.json") })
        }
      }, "path---photos-professional-21-c-4-tk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-21-c-4-tk!./.cache/json/photos-professional-21-c-4-tk.json
// module id = 674
// module chunks = 231608221292675